<template>
  <div v-if="show" class="modal-backdrop fade show"></div>
  <div v-if="show" class="modal fade show" tabindex="-1" style="display: block;" aria-modal="true" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-warning">
          <h5 class="modal-title">
            <i class="bi bi-exclamation-triangle-fill me-2"></i>
            {{ translate('credit.no_credits_title', 'Credits Required') }}
          </h5>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <div class="text-center mb-4">
            <div class="display-1 text-warning mb-3">
              <i class="bi bi-coin"></i>
            </div>
            <h4>{{ translate('credit.no_credits_subtitle', 'You have no credits left') }}</h4>
            <p class="text-muted">
              {{ translate('credit.no_credits_description', 'To create new interactions, you need to purchase more credits.') }}
            </p>
          </div>
          
          <div class="bg-light p-3 rounded mb-3">
            <h6>{{ translate('credit.benefits_title', 'Benefits of having credits:') }}</h6>
            <ul class="mb-0">
              <li>{{ translate('credit.benefit_1', 'Create unlimited interactions with your clients') }}</li>
              <li>{{ translate('credit.benefit_2', 'Send automatic reminders and follow-ups') }}</li>
              <li>{{ translate('credit.benefit_3', 'Full access to all features') }}</li>
            </ul>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">
            {{ translate('credit.close', 'Close') }}
          </button>
          <button type="button" class="btn btn-primary" @click="purchaseCredits">
            <i class="bi bi-cart-plus me-2"></i>
            {{ translate('credit.purchase_credits', 'Purchase Credits') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Eliminada la importación de computed ya que no se utiliza
import { useStore } from 'vuex'

export default {
  name: 'NoCreditsModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:show', 'purchase-credits'],
  setup(props, { emit }) {
    const store = useStore()
    
    const closeModal = () => {
      emit('update:show', false)
    }
    
    const purchaseCredits = () => {
      closeModal()
      emit('purchase-credits')
    }
    
    const translate = (key, fallback) => {
      // Use the getter from the store to handle translations correctly
      return store.getters.translate(key, fallback)
    }
  
    return {
      closeModal,
      purchaseCredits,
      translate
    }
  }
}
</script>

<style scoped>
.modal-backdrop {
  opacity: 0.5;
}
</style>
